import React from "react";
import AutomateContent from "./Main/Automate/AutomateContent";
import FreeTrialForm from "./Main/FreeTrialForm";
// import frame from "../assets/images/Frame.png";

const HeroSection: React.FC = () => {
  return (
    <section className="flex flex-col items-center px-2 sm:px-6 lg:px-20 py-8 -mt-6 lg:py-12">
      <div className="flex flex-col lg:flex-row items-start justify-center gap-8 lg:gap-4 w-full">
        {/* Left */}
        <div className="w-full lg:w-2/3">
          <AutomateContent />
        </div>

        {/* Right */}
        <div className="w-full lg:w-1/3 max-w-sm mx-auto">
          <FreeTrialForm />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
